export default __webpack_public_path__ + "images/IE.6d563ce.png";